class StickyHeader extends HTMLElement {
  constructor() {
    super();
    this.hide = this.hide.bind(this);
    this.reveal = this.reveal.bind(this);
    this.reset = this.reset.bind(this);
    this.onScrollHandler = this.onScroll.bind(this);
    this.header = document.getElementById("shopify-section-header");
    this.isHeaderSticky = false;
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;
    this.addEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp);
    window.addEventListener("scroll", this.onScrollHandler, false);
    if (this.header) {
      this.checkIfHeaderStick();
    }
    console.log("StickyHeader constructor");
  }
  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop <= 0) {
      requestAnimationFrame(this.reset);
    } else if (scrollTop > this.currentScrollTop && this.isHeaderSticky) {
      requestAnimationFrame(this.hide);
    } else if (scrollTop < this.currentScrollTop && this.isHeaderSticky) {
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal);
      } else {
        window.clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);
        requestAnimationFrame(this.hide);
      }
    } else if (!this.isHeaderSticky) {
      requestAnimationFrame(this.reset);
    }
    this.currentScrollTop = scrollTop;
  }
  hide() {
    document.body.classList.add("header-sticky");
    this.header.classList.add("shopify-section-header-hidden", "shopify-section-header-sticky");
  }
  reveal() {
    document.body.classList.add("header-sticky");
    this.header.classList.add("shopify-section-header-sticky", "header-sticky-transition");
    document.body.classList.add("sticky-header-black");
    this.header.classList.remove("shopify-section-header-hidden");
    document.body.classList.add("sticky-header-black");
  }
  reset() {
    document.body.classList.remove("header-sticky");
    document.body.classList.remove("sticky-header-black");
    this.header.classList.remove(
      "shopify-section-header-hidden",
      "shopify-section-header-sticky",
      "header-sticky-transition"
    );
  }
  checkIfHeaderStick() {
    const observer = new IntersectionObserver(([e]) => this.isHeaderSticky = e.intersectionRatio < 1, {
      threshold: [1]
    });
    observer.observe(this.header);
  }
}
customElements.define("sticky-header", StickyHeader);
